export function createState(initial) {
    let values = {...initial};
    const listeners = new Set();
    return {
        get: () => ({...values}),
        set(changes) {
            values = {...values, ...changes};
            listeners.forEach(listener => listener({...values}));
        },
        subscribe(listener) {
            listeners.add(listener);
            listener({...values});
            return () => listeners.delete(listener);
        },
    };
}
